import { useRef } from 'react';
import { mergeProps, useFocusRing, useTableColumnHeader } from 'react-aria';

import { useHeaderColumnContext } from '../SettingsTable';

import styles from './DeviceUpdatesSettingsTableColumnHeader.module.css';

export function DeviceUpdatesSettingsTableColumnHeader() {
  const { column, state } = useHeaderColumnContext();
  const ref = useRef();
  const tableColumnHeader = useTableColumnHeader({ node: column }, state, ref);
  const focusRing = useFocusRing();

  return (
    <th
      {...mergeProps(tableColumnHeader.columnHeaderProps, focusRing.focusProps)}
      className={`${styles.root} ${styles.tableColumnHeader}`}
      colSpan={column.colspan}
      ref={ref}
      data-type={column.key}
    >
      {column.rendered}
    </th>
  );
}
